const components = {
  eventsAsideIntro: {
    helloMessage: 'Welcome to Repay, a service that helps you manage financial settlements with friends when you spend money together.',
    events: 'This panel displays all the events you created or in which you were added. Dialogues with other users also appear here.',
    sort: 'Events can be sorted either by date or by status.',
    create: 'To create a new event press here.',
  },
  createEventIntro: {
    create: 'Here you can create a new event and add people to it. If you want to create a dialogue, add the desired user and leave the name and picture of the event blank.',
  },
  operationPanelIntro: {
    tabs: 'The "Operations" tab contains all actions performed in this event. The "My Share" tab contains transactions created with your participation. In "Debts" you can see who you owe and who owes you.',
    chat: 'All transactions will be displayed in the chat.',
    create: 'Various operations are provided depending on the situation. You can also write comments and exchange opinions.',
    optionsPanel: 'The settings panel helps you navigate the event, invite and exclude users, and create or delete families.',
  },
  eventFamiliesIntro: {
    explanation: 'Debts in families are counted as shared and are calculated based on the debts of all family members.',
    notInFamily: 'Users without family are at the bottom of the list.',
    create: 'To create a family, you need to drag a person to the creation field. The family must have at least one person other than the head of the family.',
  },
  introBtns: {
    skip: 'Skip',
    back: 'Back',
    next: 'Next',
    finish: 'Finish',
    allClear: 'All clear',
  },
  cardForm: {
    language: {
      short: 'Eng',
      english: 'English',
      russian: 'Russian',
      shortEng: 'Eng',
      shortRu: 'Ru',
    },
  },
  headerApp: {
    language: {
      short: 'Eng',
      english: 'English',
      russian: 'Russian',
    },
    tellAFriend: 'Tell a friend',
    people: 'People',
    events: 'Events',
    settings: 'Settings',
    productTour: 'Product tour',
    faq: 'FAQ',
    supportService: 'Contact us',
    exit: 'Exit',
  },
  eventOptions: {
    eventName: 'Event name',
    eventParticipants: 'Participants: ',
    eventUnableToDeleteUserWithDebt: 'It\'s not possible to delete the user with a debt',
    eventUnableToDeleteActiveUser: 'It\'s not possible to delete the user with operations history',
  },
  peopleList: {
    noUsers: 'No users',
  },
  addHumanButton: {
    addParticipants: 'Add participants',
  },
  eventsAside: {
    sortByUpdate: 'By update date',
    sortByCreation: 'By creation date',
    filterAll: 'All events',
    filterByDebts: 'Events with debts',
  },
  peopleAside: {
    sortAlphabetically: 'Alphabetically',
    sortByDebtAmount: 'By debt amount',
    filterAll: 'All',
    filterMyDebts: 'My debts',
    filterMyDebtors: 'My debtors',
  },
  searchInput: {
    placeholderSearch: 'Search',
  },
  eventList: {
    noEvents: 'No events yet',
    noEventsFound: 'No events found',
  },
  humanProfile: {
    makePayments: 'Repay',
  },
  proposedTransactions: {
    addTransaction: 'Add operation',
    evenPurchase: 'even',
    splitPurchase: 'split',
    iBoughtThem_M: 'I bought',
    iBoughtThem_F: 'I bought',
    theyBoughtMe: 'they bought me',
    iLentThem_M: 'I lent',
    iLentThem_F: 'I lent',
    theyLentMe: 'they lent me',
    deposit: 'income',
    comment: 'comment',
    calendarSameDay: '[Today, ] LT',
    calendarNextDay: '[Yesterday, ] LT',
  },
  emptyEventOperations: {
    youDontHaveEvents: 'You do not have any events yet.',
    createNewEvent: 'Create new event',
    toStartRepay: 'to start using Repay!',
    noEventsFound: 'No events found for this request',
    newEvent: 'Create new event',
  },
  emptyHumanProfile: {
    youDontHaveFriends: 'The friend list is empty.',
    addNewFriend: 'Add more friends',
    toStartEvents: 'to start creating events with them!',
    newFriend: 'Add a friend',
  },
};
const commonPhrases = {
  CP: {
    me: 'Me',
    meGenitive: 'Me',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    add: 'Add',
    close: 'Close',
    events: 'Events',
    confirmDeleteEvent: 'Are you sure you want to delete this event?',
    confirmDeleteAccount: 'This action is irreversable. \n Are you sure you want to delete your account?',
    currency: 'Сurrency',
    exchangeRates: 'Exchange rates',
    changeCurrency: 'Change currency',
    noDebts: 'No debts',
    myTurnToPay: 'My turn to pay',
    addUser: 'Add user',
    ready: 'Ready',
    transactions: 'Operations',
    myShare: 'My share',
    debts: 'Debts',
    amount: 'Amount',
    totalAmount: 'Total amount',
    newTransaction: 'New operation',
    purpose: 'Purpose',
    whoPays: 'Who pays',
    whoReceives: 'Who receives',
    create: 'Create',
    transactionParticipants: 'Operation participants',
    sender: 'Sender',
    recipient: 'Recipient',
    noTransactionsYet: 'No operations yet',
    turnToPay: 'Turn to pay',
    theyOweMe: 'They owe me',
    iOweThem_M: 'I owe',
    iOweThem_F: 'I owe',
    averageExpensesPerDay: 'Average expenses per day',
    people: 'People',
    enterPhoneNumber: 'Enter a phone number',
    enterNameOrPhone: 'Enter a name or a phone number',
    userNotFound: 'User not found',
    evenPurchase: 'Even',
    splitPurchase: 'Split',
    iBoughtThem_M: 'I bought',
    iBoughtThem_F: 'I bought',
    theyBoughtMe: 'They bought me',
    iLentThem_M: 'I lent',
    iLentThem_F: 'I lent',
    theyLentMe: 'They lent me',
    deposit: 'Income',
    payback: 'Repay',
    comment: 'Comment',
    theyOwesMe_M: 'Owes me',
    theyOwesMe_F: 'Owes me',
    wholeFamily: 'Whole family',
    save: 'Save',
    input: 'Input',
    participants: 'Participants',
    transferOperation: 'Transfer operation',
    restorePassword: 'Restore password',
    event: 'Event',
    clone: 'Clone',
    eventName: 'Event name',
    eventParticipants: 'Event participants',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    confirmDeleteContact: 'Are you sure you want to delete this contact?',
    addNewParticipant: 'Do you want to add a new participant?',
    noCancelExclude: 'No, cancel',
    newOperationsMessage: 'New operations',
    yesDelete: 'Yes, delete',
    yesExclude: 'Yes, exclude',
    settings: 'Settings',
    name: 'Name',
    surname: 'Surname',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    changePassword: 'Change password',
    newPassword: 'New password',
    oldPassword: 'Old password',
    weSentCode: 'We have sent you an sms with confirmation code',
    sendCodeAgain: 'Send code again',
    sendCodeTimer: 'Send code again in ',
    sendCode: 'Send code',
    confirmationCode: 'Confirmation code',
    addParticipants: 'Add participants',
    notFound404: '404 Not Found',
    unfortunately404: 'Unfortunately, there is no such page or it is under construction.',
    tryContact: 'Try to contact',
    supportService: 'our support service',
    confirmDeleteTransaction: 'Are you sure you want to delete this operation?',
    myFamily: 'My family',
    cropAThumbnail: 'Crop a thumbnail',
    offerRepay: 'I found Repay - a perfect service to calculate our financing and track our budget.',
    errorOutOfBoundsPictureCrop: 'Picture size should be between 70x70px and 10000x10000px',
    errorPictureCropUrlSize: 'Picture size is too big',
    firstName: 'First name',
    lastName: 'Last name',
    youCanCreate: 'You can create a new contact',
    userAlreadyAdded: 'User is already added',
    allParticipantsAdded: 'All participants of the event have been added to the operation',
    toAddNewUsers: 'To add new users, use the input field below',
    addEvent: 'Add event',
    familiesSettings: 'Families settings',
    changeFamily: 'Change family',
    confirmDeleteFamily: 'By deleting the family head, you will delete the whole family. Are you sure you want to delete?',
    createFamily: 'Create new family',
    confirmCreateFamily: 'Create new family?',
    chooseFamilyHead: 'Choose family head',
    chooseFamilyMembers: 'Choose family members',
    confirmSaveFamilies: 'Are you sure you want to save these families?',
    family: 'Family',
    notInFamily: 'Not in family',
    newFamily: 'New family',
    updated: 'Updated',
    toCreateQuasiEvent: 'To create a dialogue with another user',
    addUserAndDeleteImage: 'add him in the event and leave the event name and image empty',
    contactNotFound: 'The user with this phone number was not found'
      + ' you can create a new user with this phone number',
    noConvertation: 'Without conversion',
    errorOccurred: 'An error has occurred. Service is temporarily down',
    sumTotalMessage: 'Sum total (the remainder to be divided equally between the parties)',
    sumTotalMessageSplitProportional: 'Sum total (the remainder to be divided proportionally)',
    aTip: 'A tip',
    tips: 'Tips',
    serviceFee: 'Service fee',
    inviteUnregistered: 'Invite unregistered users',
    advancedOptions: 'Advanced options',
    fillInYourProfile: 'Complete your profile',
    exit: 'Exit',
    contactAlreadyAdded: 'Contact is already added',
    contactDoesNotExist: 'This user is not from your Contacts',
    deleteFamily: 'Delete family',
    quitFamily: 'Quit family',
    addNewContact: 'Add new contact',
    allowCookiesMessage: 'We use cookies on our websites. Please accept to proceed.',
    allowCookiesBttn: 'Allow',
    declineCookiesBttn: 'Decline',
    cookiesPageTitle: 'You disabled cookies',
    cookiesPageMessage: 'Please allow us to use cookies for the correct operation of the site.',
    cookiesPageBttn: 'Accept and reload the page',
    serveErrorPageTitle: 'Oops... something went wrong',
    serveErrorPageMessage: 'There seems to be a problem with the site. \n Please, try again in a few minutes.',
    serveErrorPageBttn: 'Reload the page',
    selectSearchNotFound: 'Nothing found...',
    currencyGroupUsed: 'Previously used',
    currencyGroupOthers: 'Others',
    noCurrencyFound: 'No currency found',
    transactionType: 'Operation type',
    whoPaid: 'Paid by',
    total: 'Total',
    balanceBeforeTransaction: 'Balance before operation',
    balanceAfterTransaction: 'Balance after operation',
    peopleSeenList: 'Seen by',
    proportionalRemainderSplit: 'Divide the remainder proportionally',
    uploadImage: 'Upload image',
    choosePredefinedAvatars: 'Or choose one from down below',
    gotAnyQuestions: 'Got any questions?',
    contactUs: 'Contact us',
    deleteAccount: 'Delete account',
    myTotalDebt: 'My total debt',
  },
  statusMessages: {
    iRepaidThem_M: 'I repaid {user}',
    iRepaidThem_F: 'I repaid {user}',
    theyRepaidMe_M: '{user} repaid to me',
    theyRepaidMe_F: '{user} repaid to me',
    theyRepaidThem_M: '{user1} repaid {user2}',
    theyRepaidThem_F: '{user1} repaid {user2}',
    iLentThem_M: 'I lent {user}',
    iLentThem_F: 'I lent {user}',
    theyLentMe_M: '{user} lent me',
    theyLentMe_F: '{user} lent me',
    theyLentThemselves_M: '{user} lent himself',
    theyLentThemselves_F: '{user} lent herself',
    iLentMyself_M: 'I lent myself',
    iLentMyself_F: 'I lent myself',
    theyLentThem_M: '{user1} lent {user2}',
    theyLentThem_F: '{user1} lent {user2}',
    splitFor: 'Split for',
    paidBy_M: 'Paid by',
    paidBy_F: 'Paid by',
    iBoughtFor_M: 'I bought for',
    iBoughtFor_F: 'I bought for',
    theyBoughtForMe_M: '{user} bought for me',
    theyBoughtForMe_F: '{user} bought for me',
    theyBoughtForThemselves_M: '{user} bought for himself',
    theyBoughtForThemselves_F: '{user} bought for herself',
    theyBoughtForSmb_M: '{user1} bought for {user2}',
    theyBoughtForSmb_F: '{user1} bought for {user2}',
    iBoughtForMyself_M: 'I bought for myself',
    iBoughtForMyself_F: 'I bought for myself',
    evenFor: 'Even for',
    evenForAll: 'Even for all',
    incomeFor: 'Income for',
    incomeForAll: 'Income for all',
    received_M: 'Received',
    received_F: 'Received',
    iReceivedFor_M: 'I received for',
    iReceivedFor_F: 'I received for',
    theyReceivedForThemselves_M: '{user} received for himself',
    theyReceivedForThemselves_F: '{user} received for herself',
    theyReceivedForMe_M: '{user} received for me',
    theyReceivedForMe_F: '{user} received for me',
    iReceivedForMyself_M: 'I received for myself',
    iReceivedForMyself_F: 'I received for myself',
  },
};
const forms = {
  formsCommon: {
    languageInUse: 'Language Used',
  },
  addCommentForm: {
    placeholder: 'Enter a text',
  },
  validateText: {
    required: 'Required field',
    incorrectPhone: 'The phone number you entered is not valid. Please try again.\n',
    shortPassword: 'Password is too short',
    errorLoginSubmit: 'The phone number or password you entered is incorrect.',
    errorSignUpSubmit: 'Error in registration. Please try again.',
    errorRestorePasswordSubmit: 'Server could not restore the password. Please try again later.',
    errorRestorePasswordCode: 'Server could not send the code. Please try again later.',
    errorRestorePasswordCodeUserDoesntExist: 'This user does not exist.',
    errorRestorePasswordCodeTooManyRequests: 'Too many code requests for this phone number. Please try again later.',
    errorChangePasswordSubmit: 'The old password you entered is incorrect. Please try again.',
    minimalAmount: 'Amount should not be less than',
    fillInTheFields: 'Fill in the fields',
    tooShortCode: 'Confirmation code is too short',
    minAmount: 'Amount must not be less than',
    firstNameRequired: 'First name required',
    lastNameRequired: 'Last name required',
    avatarRequired: 'Profile picture required',
    phoneIncorrect: 'Phone number is incorrect',
    eventNameRequired: 'Event name is required',
    moreThanOneParticipant: 'Operation must have two or more participants',
    allUsersAmountMoreThan: 'All users\' amount must be more than',
    anyUsersBesidesPayee: 'Operation must have any participants besides the payee',
    sumRemainderNotNegative: 'Sum remainder should not be negative',
    chooseYourCurrency: 'Choose your currency',
    senderRequired: 'Sender is required',
    recipientRequired: 'Recipient is required',
    quasiEventAlreadyExists: 'The dialogue already exists',
  },

  loginForm: {
    enter: 'Enter',
    description: 'Please enter a phone number or create an account',
    labelPhoneNumber: 'Phone number: ',
    labelPassword: 'Password: ',
    placeholderPhone: 'Enter your phone number',
    placeholderPassword: 'Input password',
    forgotPassword: 'Forgot your password?',
    keepMeSignedIn: 'Keep me logged in',
    buttonNext: 'Next',
    haveAccount: 'You don\'t have an account yet?',
    registrationLink: 'Register',
    tooltip: 'If you have previously only used the application in a smartphone, please use password recovery to log back into your account.',
  },
  signUpForm: {
    registration: 'Sign Up',
    description: 'Please enter phone number and password to create an account',
    labelPhoneNumber: 'Phone number: ',
    labelPassword: 'Password',
    placeholderPhone: 'Enter your phone number',
    placeholderPassword: 'Input password',
    keepMeSignedIn: 'Keep me logged in',
    labelSendCode: 'Confirmation code: ',
    placeholderSendCode: 'Enter code',
    getCodeButton: 'Get confirmation code',
    weSentCode: 'We have sent you an sms with confirmation code',
    sendCodeAgain: 'Send code again',
    sendCodeTimer: 'Send code again in ',
    haveAccount: 'Already have an account?',
    register: 'Register',
    loginLink: 'Login',
    userAlreadyExist: 'User with this phone already exists',
  },
  restorePasswordForm: {
    description: 'Please enter phone number and password, then confirm password change with the code from SMS',
    labelPhoneNumber: 'Phone number',
    labelPassword: 'Password',
    placeholderPhone: 'Enter your phone number',
    placeholderPassword: 'Enter password',
    confirm: 'Confirm',
    labelSendCode: 'Confirmation code',
    placeholderSendCode: 'Enter code',
    getCodeButton: 'Get confirmation code',
    weSentCode: 'We have sent you an sms with confirmation code',
    sendCodeAgain: 'Send code again',
    sendCodeTimer: 'Send code again in ',
    changePassword: 'Change password',
    loginLink: 'Login',
    or: 'or',
    registrationLink: 'Register',
  },
};
const faq = {
  faq: {
    title: 'Frequently Asked Questions',
    list: [
      {
        id: 'question-1',
        question: 'Question 1',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-2',
        question: 'Question 2',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-3',
        question: 'Question 3',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-4',
        question: 'Question 4',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-5',
        question: 'Question 5',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-6',
        question: 'Question 6',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-7',
        question: 'Question 7',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-8',
        question: 'Question 8',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-9',
        question: 'Question 9',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-10',
        question: 'Question 10',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-11',
        question: 'Question 11',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-12',
        question: 'Question 12',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-13',
        question: 'Question 13',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-14',
        question: 'Question 14',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
      {
        id: 'question-15',
        question: 'Question 15',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo possimus blanditiis laudantium. Voluptatem quos impedit dolor asperiores delectus quae ab vel ipsum, dolorem at omnis totam tempora aspernatur corporis placeat.',
      },
    ],
  },
};

export const en = {
  ...components,
  ...commonPhrases,
  ...forms,
  ...faq,
};
